<template>
  <vue-final-modal
    :hide-overlay="false"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    v-bind="$attrs"
    :click-to-Close="false"
    :esc-to-close="false"
    :focus-trap="{
      preventScroll: true,
      escapeDeactivates: false,
      allowOutsideClick: true,
    }"
  >
    <v-card variant="flat" class="main-card">
      <!-- Header -->
      <div class="d-flex align-start justify-space-between pa-2">
        <slot name="header" :cancel="cancel" :ok="ok">
          <div>
            <v-card-title class="screen-title">{{ title }}</v-card-title>
            <v-card-subtitle class="screen-sub-title" v-if="subTitle">{{
              subTitle
            }}</v-card-subtitle>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click="cancel"
          >
            ×
          </button>
        </slot>
      </div>

      <v-divider class="mt-2"></v-divider>
      <!-- BODY and FOOTER -->
      <slot name="body" :cancel="cancel" :ok="ok"></slot>
    </v-card>
  </vue-final-modal>
</template>

<script lang="ts">
import { VueFinalModal } from "vue-final-modal";
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "AppModal",
  inheritAttrs: false,
  components: { VueFinalModal },
  props: {
    title: {
      type: String,
      required: false,
    },
    subTitle: {
      type: String as PropType<string>,
      required: false,
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel", ...arguments);
    },
    ok() {
      this.$emit("ok", ...arguments);
    },
  },
});
</script>

<style lang="scss">
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;

  .vfm__content {
    padding: 1rem;
    background: #fff;
    border-radius: 0.5rem;
  }
}

// 確認ダイアログ
.confirm-modal-container {
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 16px;

  .vfm__content {
    padding: 1rem;
    background: #fff;
    border-radius: 0.5rem;
  }
}

// 中サイズダイアログ
.modal-medium {
  width: 700px;

  .modal-body {
    max-height: 70vh;
    overflow: auto;
  }
}

// 大サイズダイアログ
.modal-large {
  width: 900px;

  .modal-body {
    max-height: 70vh;
    overflow: auto;
  }
}

// 特殊サイズダイアログ
// サブネット有り/無しどちらでも可能なアドレス項目のプレースホルダー用に追加
// UIポリシーに記載されている最小解消度1280px、推奨解消度1536未満の値を設定すること
.modal-large-plus {
  width: 1070px;

  .modal-body {
    max-height: 70vh;
    overflow: auto;
  }
}

.modal-extra-large {
  width: 1250px;

  .modal-body {
    max-height: 70vh;
    overflow: auto;
  }
}

// フルサイズダイアログ
.modal-full {
  width: 90vw;

  .modal-body {
    max-height: 70vh;
    overflow: auto;
  }
}

// エラーダイアログ
.modal-error {
  min-width: 500px;
}

// ステッパー利用時のコンテンツ領域は、ヘッダーとフッターの縦幅を確保した上でcalcで計算する。
.stepper-content {
  height: calc(80vh - 242px);
}
</style>
